<div class="container-fluid p-3">
   <mat-icon class="float-right " mat-dialog-close>close</mat-icon>
  <h5> <strong> Check Available Item</strong></h5>
<div class="pt-2 py-2 w-100"  style="width:500px;overflow-x: hidden;">
<form [formGroup]="formdata" (ngSubmit)="PincodeApply()">
<div>
  <input type="tel" class="form-control" placeholder="Enter Your Area Pincode"  formControlName ="userPincode" #pincode required>
</div>
<br>
<div style="text-align: center;">

  <button type="submit" class="btn btn-primary btn-md">Apply</button>
</div>
 <div *ngIf="pinAvailToast"><span class="successToast"> {{pinAvail}}</span></div>
<!-- <div *ngIf="pinNotAvailToast"><span class="errorToast">{{pinNotAvail}}</span></div>  -->
<div class="" *ngIf="submitted && f.userPincode.errors">
<i class="fa fa-close"></i>&nbsp;&nbsp;
<div class="errorToast" *ngIf="f.userPincode.errors" >Please Enter Valid Pincode</div> 
</div>  
</form>
</div>
</div>


